<template>
  <div>
    <div class="controls" v-if="isVisibleControl">
      <IconButton variant="ghost" icon="chevron-left" :size="props.size" :disabled="left" @click="scrollTo('left')" />
      <IconButton
        variant="ghost"
        icon="chevron-right"
        :size="props.size"
        :disabled="right"
        @click="scrollTo('right')"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useElementSize, useScroll } from '@vueuse/core';
import { computed, toRefs } from 'vue';

import IconButton from './icon-button.vue';
import ScrollableHorizontallyContainer from './scrollable-horizontally-container.vue';

interface ScrollableHorizontallyControlsProps {
  scrollableContainer: InstanceType<typeof ScrollableHorizontallyContainer> | undefined;
  size?: 'medium' | 'large';
}

const props = withDefaults(defineProps<ScrollableHorizontallyControlsProps>(), { size: 'medium' });
const innerElementRef = computed(() => props.scrollableContainer?.innerElement);
const outerElementRef = computed(() => props.scrollableContainer?.outerElement);
const scrollElementRef = computed(() => props.scrollableContainer?.scrollElement);
const innerSize = useElementSize(innerElementRef, undefined, { box: 'border-box' });
const outerSize = useElementSize(outerElementRef, undefined, { box: 'border-box' });
const isVisibleControl = computed(() => innerSize.width.value > outerSize.width.value);
const { arrivedState, x } = useScroll(scrollElementRef, { behavior: 'smooth' });
const { left, right } = toRefs(arrivedState);

function scrollTo(direction: 'left' | 'right') {
  x.value += direction === 'right' ? outerSize.width.value : -outerSize.width.value;
}
</script>

<style scoped lang="scss">
.controls {
  display: flex;
  gap: 0.5rem;
}
</style>
